module.exports = __webpack_public_path__ + "img/cv.c31c863b.svg";